module.exports = __webpack_public_path__ + "static/media/key-message-benefits-480w.fd359903.png";